import { render, staticRenderFns } from "./cl-switch-tab.vue?vue&type=template&id=5d40ee1c&scoped=true"
import script from "./cl-switch-tab.vue?vue&type=script&lang=js"
export * from "./cl-switch-tab.vue?vue&type=script&lang=js"
import style0 from "./cl-switch-tab.vue?vue&type=style&index=0&id=5d40ee1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40ee1c",
  null
  
)

export default component.exports